import React from 'react'
import AccountVirtualCards from 'src/app/AccountVirtualCards/AccountVirtualCards'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { accountVirtualCardsRouteProps } from 'src/navigation/routeProps'

const AccountVirtualCardsAppRoute: AppRoute = {
  id: AppLocation.AccountVirtualCards,
  routeProps: accountVirtualCardsRouteProps,
  component: <AccountVirtualCards />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default AccountVirtualCardsAppRoute
